<template>
  <div>
    <vs-popup :title="$t('WriteAnswer')" :active.sync="showModal">
      <form>
        <vs-textarea
          v-model="modelName"
          name="Content"
          label="درج پاسخ"
          rows="3"
        />
        <vs-textarea
          v-model="lastAnswer"
          name="Content"
          label="اخرین پاسخ"
          rows="3"
          v-show="lastAnswer"
          disabled
        />
        <span class="text-danger text-sm" v-show="showError">
          "{{ $t("PleaseEnterDescription") }}."</span
        >
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import vSelect from "vue-select";

export default {
  name: "Content_management_Compalint_Confirm_AnswerPopup",
  props: {
    show: { default: false },
    lastAnswer: "",
    AllDataForCurrentQuestion: {}
  },
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      model: {
        content: "",
        parent: 0
      },
      showError: false,
      modelName: ""
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {
    ...mapActions({
      ConfirmAnswer: "complaint/ConfirmAnswer"
    }),
    submitForm() {
      if (this.modelName != "") {
        this.model = {
          content: this.modelName,
          parent: this.AllDataForCurrentQuestion.id
        };
        this.ConfirmAnswer(this.model).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "توضیحات مورد نظر با موفقیت ثبت شد!",
            showConfirmButton: false,
            timer: 2000
          });
          this.modelName = "";
          this.$emit("finish");
        });
      } else {
        this.showError = true;
      }
    }
  }
};
</script>
